<template>
    <div>
        <h3 class="cl-color-dark pl-5">{{title}}</h3>
        <div id="doc" class="pa-5"></div>
        <Carregando role="alert" id="carregando"></Carregando>
    </div>
</template>
<script>
import {getComoFunciona, getQuemSomos, getContato, getDocPoliticaPrivacidade, getDocTermoUso} from '@/service/service_autoatendimento/autoatendimentosemtoken'
import bus from '@/service/bus'
import Carregando from './MyComponents/Carregando'
// import Cookies from 'js-cookie'
export default {
    components: {Carregando},
    data() {
        return {
            title: ''
        }
    },
    mounted() {
        this.documento()
    },
    watch: {
        '$route.params.doc': function () {
            this.documento()
        }
    },
    methods: {
        documento() {
            let doc = document.getElementById('doc')
            doc.innerHTML = ""
            switch(this.$route.params.doc) {
                case 'comoFunciona':
                    this.title = 'Como Funciona'
                    this.getDocComoFunciona();
                    break;
                case 'quemSomos': 
                    this.title = 'Quem Somos'
                    this.getDocQuemSomos();
                    break;
                case 'contato': 
                    this.title = 'Contato'
                    this.getDocContato();
                    break;
                case 'politicaPrivacidade':
                    this.title = 'Política de Privacidade'
                    this.getDocPoliticaPrivacidade()
                    break;
                case 'termoUso':
                    this.title = 'Termos de Uso'
                    this.getDocTermoUso()
                    break;
            }
        },
        async getDocComoFunciona() {
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                let res = await getComoFunciona()
                let doc = document.getElementById('doc')
                doc.innerHTML = res.data.Retorno
                bus.$emit('load-out')
            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
        },
        async getDocQuemSomos() {
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                let res = await getQuemSomos()
                let doc = document.getElementById('doc')
                doc.innerHTML = res.data.Retorno
                bus.$emit('load-out')
            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
        },
        async getDocContato() {
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                let res = await getContato()
                let doc = document.getElementById('doc')
                doc.innerHTML = res.data.Retorno
                bus.$emit('load-out')
            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
        },
        async getDocPoliticaPrivacidade() {
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                let res = await getDocPoliticaPrivacidade()
                let doc = document.getElementById('doc')
                doc.innerHTML = res.data.Retorno
                bus.$emit('load-out')
            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
        },
        async getDocTermoUso() {
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                let res = await getDocTermoUso()
                let doc = document.getElementById('doc')
                doc.innerHTML = res.data.Retorno
                bus.$emit('load-out')
            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
        }
        
    }
}
</script>
